export default "__VITE_ASSET__CLJZZcfV__"